"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
const labels = exports.labels = {
  he: {
    close: 'סגירה',
    cancel: 'ביטול',
    confirm: 'אישור',
    more: 'עוד'
  },
  ar: {
    close: 'إغلاق',
    cancel: 'إلغاء',
    confirm: 'موافقة',
    more: 'اخرى'
  },
  en: {
    close: 'Close',
    cancel: 'Cancel',
    confirm: 'OK',
    more: 'more'
  }
};